import React from 'react'
import IssueNavigation from '../components/issue_navigation.js'

class IndexPage extends React.Component {
  constructor() {
    super()
  }

  render () {
    /**
     * Array of magazine years in reverse chronological order
     */
    const magazine_years = Array.from(new Set(this.props.data.allThemenJson.edges.map(issue => { return issue.node.jahr })))
      .sort((a, b) => {
        return a < b;
      })

    const issues_by_year = magazine_years.map(year => {
      return {
        year: year,
        issues: this.props.data.allThemenJson.edges
        .filter(issue => { return issue.node.jahr === year; })
        .sort((a, b) => { return a.node.monat_num < b.node.monat_num })
        .map(issue => {
          const issue_base_uri = `/issue/${issue.node.issue_date}`;

          issue.node.section_links = [
            issue.node.moving_image_count > 0 ? <li><a href={`${issue_base_uri}/moving_image/1`}>moving image</a></li> : null,
            issue.node.still_image_count > 0 ? <li><a href={`${issue_base_uri}/still_image/1`}>still image</a></li> : null,
            issue.node.textz_count > 0 ? <li><a href={`${issue_base_uri}/textz/1`}>textz</a></li> : null,
            issue.node.soundz_count > 0 ? <li><a href={`${issue_base_uri}/soundz/1`}>soundz</a></li> : null
          ]
          return issue
        })
      };
    });

    return (
      <div className="issue">
        <div className="sideBarLeft">
          <div className="impressum">
            <ul>
              <li><a href={`/about/`}>about</a></li>
              <li><a href={`/editorial/`}>editorial</a></li>
              <li><a href={`/contact/`}>contact</a></li>
            </ul>
          </div>
          <div className="archive">
            <a href="/archive/">archive</a>
          </div>
        </div>
        <div className="core-content">
          <h2>archives</h2>
          <h3>special:issues</h3>

          <p>The may 1998 issue "censoreship" showed censored works from the musée de l'art pornografique, lausanne, switzerland; the november 1998 issue was dedicated to the "phase 4" project of the künstlerhaus stuttgart and rainer gelb; in june 2001 the e-zine featured i-love-u at the "communication front" in plovdiv, bulgaria; "mars", the october 2001 issue joined www.mars-patent.org. To be continued.</p>

          <h3>i-love-u.ch V1 (1997 - 2005)</h3>

          <p>The first Version of i-love-u.ch can be found <a href="/revolution/archive/archive.htm">here</a></p>
            {issues_by_year.map((year) => {
              return (
              <div className="year">
                <h3>{year.year}</h3>
                {year.issues.map(issue => {
                  return (
                  <div className="issue-toc">
                    <div className="cover-thumbnail"><a href={`/issue/${issue.node.issue_date}`}><img src={`/media/covers/${issue.node.thema_cover_uri}`} /></a></div>
                    <div className="table-of-contents">
                      <h4>{`${issue.node.monat} ${issue.node.jahr} | ${issue.node.thema}`}</h4>
                      <IssueNavigation issue_data={issue.node} />
                    </div>
                  </div>
                  )
                })}
              </div>
              )
            })}
        </div>
        <div className="nav-and-metadata">
        </div>
      </div>
    )
  }
}

export default IndexPage

export const pageQuery = graphql`
  query issues {
    allThemenJson {
      edges {
        node {
          id
          thema
          thema_cover_uri
          jahr
          monat
          monat_num
          issue_date
          moving_image_count
          still_image_count
          textz_count
          soundz_count
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/archive.js